import { useContext, useEffect } from "react";
import { useLocation } from "react-router";
import { EmpdContext } from "../Context";

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

export default function useScreenScroll() {
  const { pathname } = useLocation();
  const { isLoading } = useMyContext();

  useEffect(() => {
    if( !isLoading ) {
      const url = window.location.href;
      const hashIndex = url.indexOf("#");
      let hash = "";

      if (hashIndex !== -1) {
        hash = url.substring(hashIndex + 1);
        const element = document.getElementById(hash);
        element.scrollIntoView({ behavior: "instant", block: "start" });
      } else {
        document.documentElement.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant", // Optional if you want to skip the scrolling animation
        });
      }
	}
  }, [pathname, isLoading]);

  return null;
}
